import axios from "axios";

export const actions = {
  addUsersDepartmentAccess(context, data) {
    return axios.post(`/Core/DepartmentAccess/Add/${data.applicationUserId}`, data.access);
  },
  removeDepartmentAccess(context, id) {
    return axios.delete(`/Core/DepartmentAccess/Remove/${id}`);
  },
  getUsersDepartmentAccess(context, applicationUserId) {
    return axios.get(`/Core/DepartmentAccess/All/${applicationUserId}`);
  },
};
